import { render, staticRenderFns } from "./SortBox.vue?vue&type=template&id=49badd27&"
import script from "./SortBox.vue?vue&type=script&lang=js&"
export * from "./SortBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports